(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/create-org', {
      templateUrl: 'modules/app/create-org/create-org.html',
      controller: 'CreateOrgCtrl'
    });
  }]).
  /**
   * Create Organization
   */
  controller('CreateOrgCtrl', ['$scope', '$location', 'wsApiUrl', '$http', 'Validation', 'User', function ($scope, $location, wsApiUrl, $http, Validation, User) {
    // Set the headline
    $scope.$emit("headline:change", "hide");
    $scope.$emit("nav:change", "hide");
    $scope.newOrg = {};
    $scope.formErrors = null;
    var user = User.get();
    $scope.showCancel = user.memberships > 1;
    $scope.saving = false;
    $scope.save = function () {
      $scope.formErrors = Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": $scope.newOrg.name
        }
      });
      if ($scope.formErrors !== null) {
        return;
      }
      $scope.saving = true;
      $http.post(wsApiUrl + "/organizations", $scope.newOrg).then(function createOrganizationSuccess() {
        $location.path("/orgs");
      }, function createOrganizationError() {
        //TODO: Use error message from server, if JSON?
        $scope.createError = "There was an error creating the organization!";
        $scope.saving = false;
      });
    };
    $scope.cancel = function () {
      $location.path("/orgs");
    };
  }]);
})();
